import { IDENTITY_WEBAPP_URL } from 'config';
import { CRM_CONTEXT } from 'containers/Redirecting/constants';
import { useTrackEvent } from 'Base/Tracking/hooks/useTrackEvent';
import { clearProfileCache } from 'utils/cache';
import { clearListCookies } from 'utils/cookies';
import RiskAssessment from './riskAssessment';

const LOGOUT_PWA_EVENT = 'logout_pwa';
const QA_DOMAIN = '.quintoandar.com.br';

const trackLogout = (origin) => {
  const trackEvent = useTrackEvent();
  trackEvent({
    event: LOGOUT_PWA_EVENT,
    extraProperties: {
      origin,
    },
  });
};

export const LOGOUT_ORIGIN = {
  USER_LOGOUT: 'userLogout',
  LOGOUT_AND_REDIRECT: 'logoutAndRedirect',
  DONE_VISITS_PERMISSIONS_ERROR: 'doneVisitPermissionsError',
  UNAUTHORIZED_REDIRECTOR: 'unauthorizedRedirector',
};

export const logout = (origin, redirectUrl) => {
  clearProfileCache();
  trackLogout(origin);
  localStorage.removeItem(CRM_CONTEXT);
  RiskAssessment.clearAccountId();
  window.location.replace(
    `${IDENTITY_WEBAPP_URL}/auth/logout?redirect=${encodeURIComponent(
      redirectUrl,
    )}`,
  );
};

export const logoutClearListCookies = (origin) => {
  clearProfileCache();
  trackLogout(origin);
  clearListCookies(QA_DOMAIN);
};
